import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { options, Topics, topics } from "@/components/one-to-one/Constants.tsx";
import MobileLayout from "@/components/one-to-one/MobileLayout.tsx";
import PageHeading from "@/components/ui/PageHeading.tsx";
import routes from "@/config/routes.ts";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import { cn } from "@edusogno/lib/utils";
import Button from "@edusogno/primitives/button";
import LoadingButton from "@edusogno/primitives/loading-button.js";
import { ScrollArea } from "@edusogno/primitives/scroll-area.js";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@edusogno/primitives/toggle-group";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints";

export default function SelectForSecondSession() {
  const navigate = useNavigate();
  const {
    // date, hour, credits,
    category,
    topic,
    freeTopic,
    setState,
    oneToOneDone,
  } = useOneToOne();

  const [step, setStep] = useState<number>(0);

  const [topicsDone, setTopicsDone] = useState<string[] | null>(null);

  const [topicSelected, setTopicSelected] = useState<Array<{
    title: string;
    complete: number;
  }> | null>(null);

  const { t } = useTranslation();
  const breakpoint = useBreakpoint();

  const isSmallScreen = ["xs", "sm", "md", "lg"].indexOf(breakpoint) !== -1;

  useEffect(() => {
    const allTopicsDone: string[] = [];

    topics[options[Number(category)]?.key as keyof Topics]?.forEach(
      (element: { title: string }) => {
        const topicDone = oneToOneDone
          .filter((el) => el.descrizione === element.title)
          .map((el) => el.descrizione)[0];

        if (topicDone) allTopicsDone.push(topicDone);
      },
    );

    setTopicsDone(allTopicsDone);
  }, [category, oneToOneDone]);

  useEffect(() => {
    const mappedTopics = topics[
      options[Number(category)]?.key as keyof Topics
    ]?.map((element: { title: string; complete: number }) => {
      if (topicsDone?.includes(element.title)) element.complete = 1;
      return element;
    });

    setTopicSelected(mappedTopics);
  }, [category, topicsDone]);

  // useEffect(() => {
  //   if (date || hour) return;
  //
  //   navigate(routes.one_to_one);
  // }, [date, hour]);

  return (
    <DashboardContentLayout className={"!px-0 pb-0 bg-secondary"}>
      {!isSmallScreen && (
        <PageHeading
          title={t("one_to_one.title")}
          subtitleClassName={"!text-light"}
          subtitle={t("one_to_one.subtitle")}
          className={"until-lg:px-4 until-lg:pb-0"}
        />
      )}
      <MobileLayout
        heading={
          step === 0
            ? t("one_to_one.mobile_selection.step.one.title")
            : t("one_to_one.mobile_selection.step.two.title")
        }
        subheading={
          step == 0
            ? t("one_to_one.mobile_selection.step.one.subtitle")
            : t("one_to_one.mobile_selection.step.two.subtitle")
        }
      >
        {step === 0 && (
          <ScrollArea className={"flex w-full"}>
            <ToggleGroup
              value={category}
              onValueChange={(el) => setState("category", el)}
              type={"single"}
              className={
                "w-full gap-4 h-full justify-center grid auto-rows-[84px]  grid-cols-3"
              }
            >
              {options?.map((r, idx) => (
                <ToggleGroupItem
                  key={"options-" + idx}
                  className={
                    "rounded-md h-full bg-[#EEEEEE] [--color:--secondary]  [--icon-color:--primary] [--fw:400] data-[state=on]:[--color:white]  data-[state=on]:[--fw:600] data-[state=on]:bg-[--primary] data-[state=on]:[--icon-color:white]  [&_p]:font-[--fw]  [&_p]:text-[--color] [&_svg]:text-[--icon-color] "
                  }
                  value={String(idx)}
                >
                  <div
                    className={
                      "w-full flex flex-col py-2 h-full justify-center gap-y-2 items-center"
                    }
                  >
                    {r?.icon}
                    <p
                      className={
                        "text-[10px] until-lg:leading-[120%] lg:text-sm"
                      }
                    >
                      {r?.text}
                    </p>
                  </div>
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </ScrollArea>
        )}

        {step === 1 && (
          <ScrollArea className={"flex w-full"}>
            <ToggleGroup
              value={topic}
              onValueChange={(el) => setState("topic", el)}
              type={"single"}
              className={
                "w-full grid-cols-1 gap-4 h-full grid auto-rows-[36px]"
              }
            >
              {topicSelected?.map((r, idx) => (
                <ToggleGroupItem
                  data-alt={String(r.complete == 1 && !freeTopic)}
                  disabled={r.complete == 1 && !freeTopic}
                  // disabled={true}
                  className={cn(
                    "rounded-[8px] relative pl-8 h-full bg-gray-100 data-[alt=true]:data-[state=off]:bg-[#EEEEEE66]  data-[alt=true]:data-[state=off]:[--color:#2D224C66]  data-[alt=false]:disabled:[--color:#2D224C66] until-md:data-[alt=false]:disabled:bg-[#EEEEEE66] data-[alt=true]:disabled:bg-gray-200/25 md:data-[alt=false]:disabled:bg-[#FFFFFF33]    disabled:opacity-100   [--color:--secondary]  [--icon-opacity:0] [--fw:400] data-[state=on]:[--color:white] data-[state=on]:bg-[--primary] data-[state=on]:[--icon-opacity:100]  [&_p]:font-[--fw]  [&_p]:text-[--color] [&>svg]:opacity-[--icon-opacity] ",
                    // "data-[alt=true]:data-[state=off]:[--color:transparent]  md:data-[alt=true]:data-[state=off]:bg-[#FFFFFF33] ",
                  )}
                  key={"topic-" + idx}
                  value={String(idx)}
                >
                  <p
                    className={
                      "w-full md:text-sm text-[12px] leading-[120%] text-start"
                    }
                  >
                    {r?.title}
                  </p>
                  <svg width="17" height="13" viewBox="0 0 17 13" fill="none">
                    <path
                      d="M5.19244 10.1924L1.69244 6.69244C1.60092 6.5998 1.49192 6.52625 1.37176 6.47605C1.25159 6.42585 1.12266 6.4 0.99244 6.4C0.862215 6.4 0.733284 6.42585 0.613124 6.47605C0.492963 6.52625 0.383962 6.5998 0.292439 6.69244C0.1998 6.78396 0.126248 6.89296 0.0760486 7.01312C0.025849 7.13328 0 7.26221 0 7.39244C0 7.52266 0.025849 7.65159 0.0760486 7.77175C0.126248 7.89191 0.1998 8.00092 0.292439 8.09244L4.48244 12.2824C4.87244 12.6724 5.50244 12.6724 5.89244 12.2824L16.4924 1.69244C16.5851 1.60092 16.6586 1.49192 16.7088 1.37175C16.759 1.25159 16.7849 1.12266 16.7849 0.992439C16.7849 0.862214 16.759 0.733284 16.7088 0.613124C16.6586 0.492963 16.5851 0.383962 16.4924 0.292439C16.4009 0.1998 16.2919 0.126248 16.1718 0.0760484C16.0516 0.0258488 15.9227 0 15.7924 0C15.6622 0 15.5333 0.0258488 15.4131 0.0760484C15.293 0.126248 15.184 0.1998 15.0924 0.292439L5.19244 10.1924Z"
                      fill="white"
                    />
                  </svg>
                  {!freeTopic && r.complete == 1 && (
                    <div
                      className={
                        " md:w-[131px] opacity-100 px-2 text-[12px] font-normal flex  flex-row items-center justify-between  h-5 shrink-0 border bg-[--green100] rounded-[5px] border-solid border-[--green100]"
                      }
                    >
                      <p className={"hidden md:block"}>
                        {t("one_to_one.topic.status.done")}
                      </p>

                      <p className={"md:hidden"}>
                        {t("one_to_one.topic.status.done_shorter")}
                      </p>
                      <svg
                        className={" until-md:hidden"}
                        width="19"
                        height="20"
                        viewBox="0 0 19 10"
                        fill="none"
                      >
                        <path
                          d="M13.63 0.239277C13.5555 0.165667 13.4669 0.107267 13.3694 0.0674215C13.2719 0.0275754 13.1674 0.00706525 13.0619 0.00706525C12.9564 0.00706525 12.8519 0.0275754 12.7544 0.0674215C12.6569 0.107267 12.5683 0.165667 12.4938 0.239277L7.9487 4.71766L9.08497 5.83725L13.63 1.35093C13.9363 1.0492 13.9363 0.541012 13.63 0.239277ZM17.0469 0.231337L9.08497 8.07644L6.28057 5.32113C6.12989 5.17266 5.92553 5.08925 5.71244 5.08925C5.49935 5.08925 5.29498 5.17266 5.1443 5.32113C4.99363 5.46959 4.90898 5.67096 4.90898 5.88092C4.90898 6.09089 4.99363 6.29225 5.1443 6.44072L8.51281 9.7598C8.82709 10.0695 9.33479 10.0695 9.64907 9.7598L18.1832 1.35887C18.2579 1.28541 18.3171 1.19816 18.3576 1.1021C18.398 1.00604 18.4188 0.903069 18.4188 0.799075C18.4188 0.695081 18.398 0.592108 18.3576 0.49605C18.3171 0.399993 18.2579 0.312737 18.1832 0.239277H18.1751C18.1024 0.164321 18.0151 0.104519 17.9185 0.0634198C17.8219 0.0223201 17.7179 0.000760338 17.6127 1.97509e-05C17.5075 -0.000720836 17.4032 0.0193727 17.306 0.0591083C17.2088 0.098844 17.1207 0.157412 17.0469 0.231337ZM0.591183 6.44866L3.95969 9.76774C4.27397 10.0774 4.78167 10.0774 5.09595 9.76774L5.66006 9.21192L1.72745 5.32113C1.6529 5.24752 1.56434 5.18912 1.46685 5.14927C1.36936 5.10942 1.26486 5.08891 1.15932 5.08891C1.05377 5.08891 0.949268 5.10942 0.85178 5.14927C0.754292 5.18912 0.665737 5.24752 0.591183 5.32113C0.276897 5.6308 0.276897 6.13899 0.591183 6.44866Z"
                          fill="#2D224C"
                        />
                      </svg>
                    </div>
                  )}
                  {freeTopic && (
                    <div
                      className={
                        " md:w-[131px] opacity-100 px-2 text-[12px] font-normal flex  flex-row items-center justify-between  h-5 shrink-0 border bg-[--green100] rounded-[5px] border-solid border-[--green100]"
                      }
                    >
                      <p className={"hidden md:block"}>free topic</p>
                      <p className={"md:hidden"}>free</p>
                      <svg
                        width="15px"
                        height="15px"
                        viewBox="0 0 0.45 0.45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.225 0.075a0.06 0.06 0 0 0 -0.057 0.057v0.057H0.338a0.038 0.038 0 0 1 0.038 0.038v0.15a0.038 0.038 0 0 1 -0.038 0.038h-0.225A0.038 0.038 0 0 1 0.075 0.377v-0.15a0.038 0.038 0 0 1 0.038 -0.038h0.019V0.132C0.132 0.081 0.174 0.038 0.226 0.038s0.095 0.042 0.095 0.095a0.019 0.019 0 1 1 -0.038 0A0.06 0.06 0 0 0 0.226 0.075m-0.112 0.15v0.15h0.225V0.225z"
                          fill="#0D0D0D"
                        />
                      </svg>
                    </div>
                  )}
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </ScrollArea>
        )}
        {/*</div>*/}
        <div
          className={
            "flex w-full row mt-auto items-end flex-1 justify-center gap-x-2"
          }
        >
          <Button
            color={"white"}
            size={"md"}
            onClick={() => (step === 0 ? navigate(-1) : setStep((r) => r - 1))}
          >
            {/* Go back */}
            {t("btns.back")}
          </Button>
          <LoadingButton
            disabled={(step === 0 && !category) || (step === 1 && !topic)}
            size={"md"}
            color={"primary"}
            onClick={() =>
              step >= 1
                ? navigate(routes.one_to_one_confirm_second_session)
                : setStep((r) => r + 1)
            }
          >
            {t("btns.next")}
          </LoadingButton>
        </div>
      </MobileLayout>
    </DashboardContentLayout>
  );
}
